export default function SubtileShine() {
  return (
    <div className="absolute inset-0 rounded-full pointer-events-none">
      <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 
        opacity-0 rounded-full transform -translate-x-full hover:opacity-100 hover:animate-shine" />
    </div>
  )
}